"use client";

import { Button } from "@/components/atoms/Button/Button";
import { Input } from "@/components/atoms/Input/Input";
import { Text } from "@/components/atoms/Text/Text";
import type { ReactNode } from "react";
import { useCheckMCPConnection } from "./useCheckMCPConnection";

interface Props {
  serverURL: string;
  actions?: ReactNode;
}

export function PublicMCPPanel({ serverURL, actions }: Props) {
  const { check, isPending, toolCount, error } =
    useCheckMCPConnection(serverURL);
  return (
    <div className="flex flex-col gap-4" data-sentry-component="PublicMCPPanel" data-sentry-source-file="PublicMCPPanel.tsx">
      <Input
        id="public-mcp-server-url"
        label="Server URL"
        type="url"
        value={serverURL}
        readOnly
      data-sentry-element="Input" data-sentry-source-file="PublicMCPPanel.tsx" />
      <Text variant="small" tone="secondary" data-sentry-element="Text" data-sentry-source-file="PublicMCPPanel.tsx">
        This server can be used without connecting an account.
      </Text>
      {toolCount !== null && (
        <Text variant="body" role="status">
          {toolCount === 0
            ? "Connected, but this server returned no tools."
            : `${toolCount} ${toolCount === 1 ? "tool" : "tools"} available.`}
        </Text>
      )}
      {toolCount !== null && (
        <Text variant="small" tone="secondary">
          This service needs no sign-in, so nothing was saved. Add it to a
          workflow or ask an expert to use it.
        </Text>
      )}
      {error && (
        <Text variant="small" role="alert" tone="error-strong">
          {error}
        </Text>
      )}
      <div className="flex items-center justify-end gap-2">
        {actions}
        <Button
          variant="primary"
          size="small"
          onClick={check}
          loading={isPending}
        data-sentry-element="Button" data-sentry-source-file="PublicMCPPanel.tsx">
          Check connection
        </Button>
      </div>
    </div>
  );
}
